import React from 'react';

import './OnCallReportFiltersSidebar.css';


export default function OnCallReportFiltersSidebar(props) {
    const {
        callTypeOptions = [],
        lessonOptions = [],
        selectedCallTypes = [],
        selectedLessons = [],
        pupilGroupFilters = {},
        onToggleCallType,
        onToggleLesson,
        onPupilGroupFilterChange,
        onResetFilters,
        hasActiveFilters = false,
    } = props;
    const pupilGroupOptions = [
        { key: 'FSM', label: 'FSM' },
        { key: 'ALN', label: 'ALN' },
        { key: 'MTT', label: 'MTT' },
    ];
    const radioOptions = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
        { value: 'all', label: 'All Learners' },
    ];

    return (
        <aside className='oncall_reportFilters_sidebar'>
            <div className='oncall_reportFilters_panel'>
                <h2 className='oncall_reportFilters_title'>Filters</h2>

                <div className='oncall_reportFilters_section'>
                    <div className='oncall_reportFilters_checkboxList'>
                        <p className='oncall_reportFilters_label oncall_reportFilters_label--grouped'>Call Type</p>
                        {callTypeOptions.map((callType) => {
                            const typeName = callType?.typeName || 'Unknown Type';
                            const isChecked = selectedCallTypes.includes(typeName);

                            return (
                                <label key={typeName} className='oncall_reportFilters_checkboxRow'>
                                    <input
                                        type='checkbox'
                                        className='oncall_reportFilters_checkbox'
                                        checked={isChecked}
                                        onChange={() => onToggleCallType(typeName)}
                                    />
                                    <span
                                        className='oncall_reportFilters_colourDot'
                                        style={{ backgroundColor: callType?.colourCode || '#54abcd' }}
                                    />
                                    <span className='oncall_reportFilters_checkboxText'>{typeName}</span>
                                </label>
                            );
                        })}
                    </div>
                </div>

                <div className='oncall_reportFilters_section'>
                    <div className='oncall_reportFilters_checkboxList'>
                        <p className='oncall_reportFilters_label oncall_reportFilters_label--grouped'>Groups</p>
                        {pupilGroupOptions.map((groupOption) => (
                            <div key={groupOption.key} className='oncall_reportFilters_radioGroup'>
                                <p className='oncall_reportFilters_radioGroupLabel'>{groupOption.label}</p>
                                {radioOptions.map((radioOption) => (
                                    <label
                                        key={`${groupOption.key}-${radioOption.value}`}
                                        className='oncall_reportFilters_radioRow'
                                    >
                                        <input
                                            type='radio'
                                            className='oncall_reportFilters_radio'
                                            name={`oncall-report-group-${groupOption.key}`}
                                            value={radioOption.value}
                                            checked={(pupilGroupFilters?.[groupOption.key] || 'all') === radioOption.value}
                                            onChange={() => onPupilGroupFilterChange(groupOption.key, radioOption.value)}
                                        />
                                        <span className='oncall_reportFilters_checkboxText'>{radioOption.label}</span>
                                    </label>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>

                <div className='oncall_reportFilters_section'>
                    <div className='oncall_reportFilters_checkboxList'>
                        <p className='oncall_reportFilters_label oncall_reportFilters_label--grouped'>Lesson Time</p>
                        {lessonOptions.map((lessonName) => {
                            const isChecked = selectedLessons.includes(lessonName);

                            return (
                                <label key={lessonName} className='oncall_reportFilters_checkboxRow'>
                                    <input
                                        type='checkbox'
                                        className='oncall_reportFilters_checkbox'
                                        checked={isChecked}
                                        onChange={() => onToggleLesson(lessonName)}
                                    />
                                    <span className='oncall_reportFilters_checkboxText'>{lessonName}</span>
                                </label>
                            );
                        })}
                    </div>
                </div>

                <button
                    type='button'
                    className='oncall_reportFilters_clearButton'
                    onClick={onResetFilters}
                    disabled={!hasActiveFilters}
                >
                    Clear filters
                </button>
            </div>
        </aside>
    );
}
